import { memo } from 'react'
import FolderTree from './FolderTree'
import { FolderTreeNode, DragDropHandlers, StorageUsage } from '@features/file-explorer/types'

interface FileExplorerSidebarProps {
  tree: FolderTreeNode[]
  currentFolderId: string | null
  onNavigate: (folderId: string | null) => void
  loadingFolderId: string | null
  dragAndDrop: DragDropHandlers
  storageUsage: StorageUsage | null
  isOpen: boolean
  onToggle: () => void
}

function FileExplorerSidebar({
  tree,
  currentFolderId,
  onNavigate,
  loadingFolderId,
  dragAndDrop,
  storageUsage,
  isOpen,
  onToggle
}: FileExplorerSidebarProps) {

  return (
    <>
      {/* Folder Tree Sidebar - Desktop */}
      {isOpen && (
        <div className="hidden lg:block w-64 flex-shrink-0">
          <div className="rounded-lg shadow-md h-full flex flex-col">
            <FolderTree
              tree={tree}
              currentFolderId={currentFolderId}
              onNavigate={onNavigate}
              loadingFolderId={loadingFolderId}
              dragAndDrop={dragAndDrop}
              storageUsage={storageUsage}
            />
          </div>
        </div>
      )}

      {/* Folder Tree Sidebar - Mobile Drawer */}
      {isOpen && (
        <div className="lg:hidden fixed inset-0 z-40 bg-black/50" onClick={onToggle}>
          <div
            className="absolute left-0 top-0 bottom-0 w-80 max-w-[85vw] bg-base-200 shadow-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="h-full flex flex-col">
              <FolderTree
                tree={tree}
                currentFolderId={currentFolderId}
                onNavigate={(folderId) => {
                  onNavigate(folderId)
                  onToggle()
                }}
                loadingFolderId={loadingFolderId}
                dragAndDrop={dragAndDrop}
                storageUsage={storageUsage}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

// Custom comparison to prevent unnecessary re-renders
function arePropsEqual(prevProps: FileExplorerSidebarProps, nextProps: FileExplorerSidebarProps) {
  return (
    prevProps.tree === nextProps.tree &&
    prevProps.currentFolderId === nextProps.currentFolderId &&
    prevProps.loadingFolderId === nextProps.loadingFolderId &&
    prevProps.dragAndDrop.isDragging === nextProps.dragAndDrop.isDragging &&
    prevProps.dragAndDrop.dragOverTarget === nextProps.dragAndDrop.dragOverTarget &&
    prevProps.storageUsage === nextProps.storageUsage &&
    prevProps.isOpen === nextProps.isOpen
  )
}

export default memo(FileExplorerSidebar, arePropsEqual)
